import { getAuth } from "firebase/auth";
import { redirect } from "react-router-dom";
import type { ListingDetailsKind, ListingDetailsResult } from "~/types/listing";
import { ROUTES, redirectToSignupWithReturnUrl } from "~/utils";
import { apiClient } from "~/services/apiClient";

export async function loadListingDetails(
  request: Request,
  kind: ListingDetailsKind,
  id: string
): Promise<ListingDetailsResult> {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    return redirectToSignupWithReturnUrl(request) as never;
  }

  const trimmedId = id.trim();
  if (!trimmedId) {
    throw redirect(ROUTES.unit);
  }

  const response = await apiClient.loader<ListingDetailsResult>("listing-details", {
    kind,
    id: trimmedId,
  });

  if (!response.success || !response.data) {
    const message = response.error ?? "Failed to load listing details";
    const isNotFound = /not found|not available/i.test(message);
    throw new Response(message, {
      status: isNotFound ? 404 : 500,
    });
  }

  return response.data;
}
